export default __webpack_public_path__ + "static/media/wallet.dded073f.svg";